<template>
  <div 
    class="sm-signature"
    @click="change"
  >
    <VueSignaturePad
      :class="{
        'sm-signature__canvas': true,
        'empty': isEmpty
      }"
      width="100%"
      height="220px"
      ref="signaturePad"
    />
    <checkbox-block
      v-model="confirmed"
      :text="confirmText"
    />
    <btn-block 
      v-if="!confirmText.length || confirmed"
      :class="{
        'sm-signature__save': true,
        'disabled': isEmpty
      }"
      :text="saveText"
      @click="save"
    />
    <btn-block 
      v-if="showUndo"
      :type="'small'"
      :class="'sm-signature__undo'"
      :text="'Undo'"
      @click="undo"
    />
  </div>
</template>

<script>
// import VueSignaturePad from 'vue-signature-pad';
import Checkbox from '@/components/Checkboxes';

export default {
  name: 'signature-block',
  components: {
    // 'signature-pad': VueSignaturePad,
    'checkbox-block': Checkbox
  },
  props: {
    saveText: {
      type: String,
      default: 'Sign'
    },
    confirmText: {
      type: String,
      default: ''
    },
    showUndo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      confirmed: false,
      isEmpty: true
    };
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
      this.isEmpty = this.$refs.signaturePad.isEmpty();
    },
    save() {
      const { data } = this.$refs.signaturePad.saveSignature();
      this.$emit('sign', data);
    },
    change() {
      this.isEmpty = this.$refs.signaturePad.isEmpty();
    }
  }
}
</script>
